import {connect} from 'react-redux';
import report from '../utils/report';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    print: x => x
  },
  {
    title: 'Parent',
    dataIndex: 'parentName',
    key: 'parentId',
    print: x => x || '-'
  },
  {
    title: 'Tax Group',
    dataIndex: 'taxGroupName',
    key: 'taxGroupId',
    print: x => x || '-'
  },
];

export const CategoriesReport = report("Inventory Categories", "categories", columns, 'categoryId',
  (props) => ({
    where: {
      salonId: {eq: props.salonId},
    },
    limit: 10000,
    order: 'name ASC',
  })
);

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
});
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CategoriesReport);



// WEBPACK FOOTER //
// ./src/Category/CategoriesReport.js